import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function ChartPerformanceOverall({ xlabel, sum_time, sum_code, plotdata, plotcolor2, plotname2, plotdata2, chart_style, cod, max, interval, group_handle, plot_color, co2factor }) {

    const groupname = group_handle
    const plotmap = []
    const plotcolor = plot_color
    const ispercent = chart_style?.ispercent
    const indexlabel = chart_style?.indexlabel
    const xformat = chart_style?.xformat
    const tooltip_header = chart_style?.tooltip_header
    const tooltip_format = chart_style?.tooltip_format
    const plot_buffer = plotdata
    const plot = []
    const yformat = chart_style?.yformat
    const co2_factor = co2factor

    if (groupname.length > 0) {
        for (let i = 0; i < groupname.length; i++) {
            plot.push({ color: plotcolor[i], unit: chart_style.unit, name: groupname[i] + ' Business', dp: chart_style.digit })
        }
        plot.push({ color: plotcolor2, unit: chart_style.unit, name: plotname2, dp: chart_style.digit })
    }
    if (plotdata !== null && plotdata !== undefined && groupname.length > 0) {
        for (let i = 0; i < plotdata.length; i++) {
            if (plotdata[i].length > 0 && i < (plot.length - 1)) {
                plotmap.push({
                    type: chart_style.type,
                    markerType: "circle",
                    markerSize: 0,
                    name: plot[i].name,
                    color: plot[i].color,
                    axisYIndex: 0,
                    dataPoints: plotdata[i],
                    lineThickness: 2,
                    indexLabelFontSize: 10,
                    indexLabelFontWeight: "bold",
                    indexLabelFontFamily: 'poppins',
                    indexLabelPlacement: "outside",
                    indexLabelOrientation: indexlabel,
                    indexLabelFormatter:
                        function (e) {
                            if (window.screen.width < 576) {
                                return ""
                            }
                            if (indexlabel !== "-") {
                                if (!ispercent) {
                                    if (sum_code !== "PRG" && sum_code !== "PR" && sum_code !== "ORG" && sum_code !== "ORx" && plot_buffer[e.dataSeries.index] !== undefined) {
                                        const index = e.dataSeries.dataPoints.findIndex(item => item.x === e.dataPoint.x);
                                        const avg = sum_time[index][sum_code]
                                        const filtered = plot_buffer.filter((item, id) => item.length > 0).filter((item, id) => id > e.dataSeries.index && item[index].y !== null);
                                        if (filtered.length === 0) {
                                            if (yformat !== undefined) {
                                                if (yformat === '#0.###,.k') {
                                                    return (avg / 1000).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + 'k'
                                                } else if (yformat === '#0.###,.,.M') {
                                                    return (avg / 1000000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'M'
                                                }
                                            }
                                            return avg.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                                        }
                                    }
                                    return ""
                                }
                            }
                            return ""
                        }
                })
            }
        }
        plotmap.push(
            {
                type: 'line',
                markerType: "circle",
                markerSize: 0,
                name: plotname2,
                color: plotcolor2,
                axisYIndex: 0,
                dataPoints: plotdata2,
                lineThickness: 2,
                indexLabelFontSize: 10,
                indexLabelFontWeight: "bold",
                indexLabelFontFamily: 'poppins',
                indexLabelPlacement: "outside",
                indexLabelOrientation: indexlabel,
                indexLabelFormatter:
                    function (e) {
                        if (window.screen.width < 576) {
                            return ""
                        }
                        const index = e.dataSeries.dataPoints.findIndex(item => item.x === e.dataPoint.x);
                        if (indexlabel !== "-") {
                            if (e.dataPoint.y !== undefined) {
                                if (e.dataSeries.name === "PR Guarantee" || e.dataSeries.name === "OR Guarantee") {
                                    const avg = sum_time[index][sum_code]
                                    if (avg > -1) {
                                        if (avg >= 100 || avg === 0) {
                                            return avg.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                        } else {
                                            return avg.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                        }
                                    }
                                }
                            }
                        }
                        return ""
                    }
            })
    }

    var cod_strip = []
    if (cod !== null) {
        cod_strip = [
            {
                startValue: new Date(cod.CODIndex_Start),
                endValue: new Date(cod.CODIndex_Stop),
                color: "#d8d8d8"
            }
        ]
    }

    var xoverlap_startxx = 0
    if (window.screen.width < 576) {
        if (xformat.includes(":mm")) {
            xoverlap_startxx = 3
        } else if (xformat.includes("YYYY")) {
            if (plot_buffer[0] !== undefined) {
                if (plot_buffer[0][0] !== undefined) {
                    const syear = Number(moment(new Date(plot_buffer[0][0].x)).format("YYYY"))
                    xoverlap_startxx = syear - 1
                }
            }
        }
    }

    const options = {
        height: chart_style.height,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (e.entries[0].dataPoint !== undefined) {
                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">' + tooltip_header + ' : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format(tooltip_format) + '</p>'
                    if (co2_factor !== undefined) {
                        if (e.entries[0] !== undefined) {
                            if (e.entries[0].index !== undefined) {
                                if (co2_factor[e.entries[0].index] !== undefined) {
                                    elem += '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">CO<sub>2</sub> Factor : ' + co2_factor[e.entries[0].index] + ' kgCO<sub>2</sub>/1kWh</p>'
                                }
                            }
                        }
                    }
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                elem += '<div class="measure-rows font-bold " style = "font-family: Inter !important">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp }) + '</div>' +
                                    '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                            }
                        }
                    }
                    if (!ispercent) {
                        elem += '<div class="measure-rows font-bold">' +
                            '<div class="measure-cell" style = "color:#000;font-size: 11px !important;min-width:150px  !important;">Total</div>' +
                            '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + sum_time[e.entries[0].index][sum_code].toLocaleString('en-US', { minimumFractionDigits: plot[0].dp, maximumFractionDigits: plot[0].dp }) + '</div>' +
                            '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + plot[0].unit + '</div>' +
                            '</div>'
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 'normal',
            horizontalAlign: "left"
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 12,
            fontWeight: 'normal',
            cursor: "pointer",
            fontColor: '#000',
            horizontalAlign: "center", // "center" , "right"
            verticalAlign: "top",  // "top" , "bottom"
        },
        axisX: {
            interval: 1,
            intervalType: chart_style.xinterval,
            labelFormatter: function (e) {
                if (window.screen.width < 576) {
                    const sxs = moment(new Date(e.value)).format(xformat.replaceAll(":mm", "").replaceAll("MMM", "MM"))
                    const nx = Number(sxs - xoverlap_startxx)
                    if (nx >= 1 && nx % 2 === 0) {
                        return ""
                    }
                }
                return moment(new Date(e.value)).format(xformat)
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: 'poppins',
            labelFontSize: 10,
            title: xlabel,
            margin: -5,
            crosshair: {
                enabled: true,
                snapToDataPoint: true,
                color: "orange",
                labelFontColor: "#F8F8F8",
                labelBackgroundColor: "#1A5276",
            },
            minimum: chart_style.start,
            stripLines: cod_strip,
        },
        axisY: [{
            title: chart_style.axis_y1,
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "Inter",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "#AEB6BF",
            minimum: 0,
            maximum: max,
            interval: interval,
            valueFormatString: chart_style.yformat
        }],
        data: plotmap
    }

    return (
        <div className="dashboard-chart-wrapper" style={{ cursor: "pointer important" }}>
            <CanvasJSChart options={options}
            />
        </div>
    );
}
